module.exports = ".notification-box {\n  height: 100%; }\n\n.notification-center {\n  width: 44%;\n  margin: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-details/notification-details.component.scss
// module id = ./src/app/notification-details/notification-details.component.scss
// module chunks = main